/**
 * Border Radius Design Tokens
 * Semantic radius tokens for consistent rounded corners
 * Based on DESIGN_TOKENS.md specification
 */

export const radius = {
  // Base radius values
  0: '0',
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  full: '9999px',

  // Semantic radius (component-specific)
  button: '8px',      // Small, tight
  card: '16px',       // Medium, prominent
  modal: '20px',      // Large, dialog
  avatar: '9999px',   // Circular
  pill: '9999px',     // Fully rounded
  input: '8px',
  popover: '12px',
  tooltip: '6px',
};

export type Radius = typeof radius;
export type RadiusValue = string;
